<template>
  <wtFormRight>
    <!-- -TOOLBARS -->
    <template slot="toolbars">
      <Toolbars
        :objProps="objItem"
        :objPropsData="objItemData"
        :urlServices="urlServices"
        :primary_key="primary_key"
        :nameObjData="nameObjData"
        :requiredEndDt="requiredEndDt"
        :noDelete="noDelete"
      />
    </template>

    <!-- VIEW TABLE -->
    <template slot="table" v-if="showGrid">
      <BpmProcessVersionGrid @selectedBpmProcessVersion="objRowSelected = $event"></BpmProcessVersionGrid>
    </template>

    <!-- VIEW FORM -->
    <template slot="form" v-if="!showGrid">
      <b-form class="text-uppercase">
        <div class="form-row">
          <div class="form-group col-md-6">
            <label for="bpm_process_id">Process ID</label>
            <input
              type="text"
              class="form-control"
              id="bpm_process_id"
              v-model.trim="objItemData.bpm_process_id"
              readonly
            />
          </div>
        </div>
        <hr class="mb-4" />
        <div class="form-row">
          <div class="form-group col-md-4">
            <label for="bpm_process_version_number">Version</label>
            <input
              type="text"
              class="form-control"
              id="bpm_process_version_number"
              v-model.trim="objItemData.version_number"
              @keyup="verifyVersion"
            />
          </div>
          <div class="form-group col-md-4">
            <label for="bpm_process_version_description">Version Description</label>
            <input
              type="text"
              class="form-control"
              id="bpm_process_version_description"
              v-model.trim="objItemData.bpm_process_version_description"
            />
          </div>
          <div class="form-group col-md-4">
            <!-- TIME STAMP INIT -->
            <label for="bpm_process_init_dt" v-if="!objItem.bpm_process_version_id">init. Date</label>
            <input
              v-if="!objItem.bpm_process_version_id"
              type="date"
              class="form-control"
              id="bpm_process_init_dt"
              v-model.trim="objItemData.init_dt"
            />
            <!-- TIME STAMP END -->
            <label for="bpm_process_init_dt" v-if="objItem.bpm_process_version_id">End Date</label>
            <input
              v-if="objItem.bpm_process_version_id"
              type="date"
              class="form-control"
              id="bpm_process_init_dt"
              v-model.trim="objItemData.end_dt"
            />
          </div>
        </div>
        <p
          v-if="!regexVersionTest"
          style="color:red;font-size:.7rem"
        >The version field is incorrect, use the format: 0.0.0</p>

        <input
          type="hidden"
          class="form-control"
          id="bpm_task_role_id_alloweds"
          v-model.trim="objItemData.role_id_alloweds"
        />
        <SecurityRoleSelect
          :base_id="objItem.security_role_id"
          :role_list="objItemData.role_id_alloweds"
          @roleIdList="updateRole"
        ></SecurityRoleSelect>
      </b-form>
    </template>
  </wtFormRight>
</template>
<script>
/** RECURSOS DO VUE **/
import { baseApiUrl, baseApiPort } from "@/global";
import axios from "axios";

/* COMPONENTS - LAYOUT */
import wtFormRight from "@/components/forms/wtFormRight";
import Toolbars from "@/components/widgets/Toolbars";

/* COMPONENTS - PAGE */
import BpmProcessVersionGrid from "./BpmProcessVersionGrid";
import SecurityRoleSelect from "@/modules/security_ds/internal/security_role/SecurityRoleSelect";

export default {
  name: "BpmProcessVersion",

  /* COMPONENTS IN USE */
  components: {
    wtFormRight,
    Toolbars,
    BpmProcessVersionGrid,
    SecurityRoleSelect
  },

  /* COMPUTED VARIABLES */
  computed: {
    showGrid() {
      return this.$store.state.layout.showGrid;
    },
    urlServicesStore() {
      return this.$store.state.urlServicesStore;
    },
    objShared() {
      return this.$store.state.objShared;
    },
    objSelected() {
      return this.$store.state.objSelected;
    },
    objProcess() {
      return this.$store.state.objProcess;
    },
    action() {
      return this.$store.state.action;
    }
  },

  /* VARIABLES */
  data: function() {
    return {
      /* Controls */
      urlServices: "chameleon-ds/api/internal/bpm-process-version",
      primary_key: "bpm_process_version_id",

      /* Objects Page */
      objItem: {},
      objItemData: {},
      objRowSelected: {},
      nameObjData: "bpm_process_version_data",
      requiredEndDt: false,
      noDelete: true,

      /* Others Query */
      regexVersionTest: true
    };
  },

  /* METHODS */
  methods: {
    load(objItem) {
      this.$store.commit("setShowLoading", true);
      this.$store.commit("setShowGrid", false);

      const param = {};
      param[`${this.primary_key}`] = objItem[`${this.primary_key}`];
      const url = `${baseApiUrl}:${baseApiPort}/${this.urlServices}/find/`;

      axios.post(url, param).then(res => {
        this.objItem = res.data[0];
        this.objItemData = this.objItem[`${this.nameObjData}`];
        this.$store.commit("setShowLoading", false);
      });
    },
    verifyVersion() {
      const verify = /^([0-9]+)\.([0-9]+)\.([0-9]+)$/;
      this.regexVersionTest = verify.test(this.objItemData.version_number);
    },
    updateRole(payload) {
      this.objItemData.role_id_alloweds = payload;
    }
  },

  /* WATCH */
  watch: {
    objRowSelected() {
      this.load(this.objRowSelected);
      this.$store.commit("setAction", "modify");
    },
    /* pay attention, this watcher has been changed */
    action() {
      if (this.urlServicesStore === this.urlServices) {
        if (this.action === "reset") {
          this.objItem = {};
          this.objItemData = {};
        }
      }
    },
    showGrid() {
      if (this.showGrid) {
        this.objItem = {};
        this.objItemData = {};
      } else {
        /* set process id to version */
        if (this.objProcess)
          if (this.objProcess.process_data)
            this.objItemData.bpm_process_id = this.objProcess.process_data.bpm_process_id;
      }
    }
  }
};
</script>